import styled from 'styled-components';

/** The icon in front of a contact is its action (call, write, open the map). */
export const ContactAction = styled.a`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: ${({theme}) => theme.getSize(8)};
  height: ${({theme}) => theme.getSize(8)};
  border-radius: ${({theme}) => theme.radii.circular};
  background-color: ${({theme}) => theme.colors.palettes.blue[10][100]};
  transition: background-color 250ms;
  user-select: none;

  &:hover {
    background-color: ${({theme}) => theme.colors.palettes.blue[20][100]};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({theme}) => theme.shadows.active};
  }
`;
